import React, { useEffect, useState }  from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
// Application imports
import SubmissionPopupError from "../components/SubmissionPopupError"
import SubmissionDialog from "./SubmissionDialog";
import SubmissionHeader from "../components/SubmissionHeader";
import ErrorDialog from "../components/ErrorDialog";
import TableSubmit from '../components/TableSubmit';
import getExperimentExcel from '../components/getExperimentExcel'
import { isSolveRDSelected,isAnyMonths12,addEmbargoPeriodReason,removeEmbargoPeriodReason,showHideEmbargoPeriodReason } from './UtilExperimentSubmission.js'
import { validateForm, fetchHeadersList,fetchSubprojectList } from './UtilExperimentSubmission.js'
import { parseSelectServerSide, getApiKey } from './UtilExperimentSubmission.js'
import { participant_list, experiment_create } from '../../../service/apis.js';
import header_experiment_config from "../components/headers";
import auth from '../../../service/Auth';
import { addRows, resetFormControls, hasErrors, getFilledRows, getNumbersErrors } from '../components/UtilSubmissionTable';
import { descending } from 'd3';
import LoadingSpinner from '../../components/LoadingSpinner.js';


const config = window.config;


const SubmitExperiment = (props) => {
    // Component hooks
    const [numberRows, setNumberRows] = useState(10);
    const [headers, setHeaders] = useState(header_experiment_config);
    const [formControls, setFormControls] = useState(
        [
          [ 
            {id:"Participant_ID", index:0, value:'----', valueIndex:null, error:''},{id:"Experiment",index:0, value:'',error:''},
            {id:"Projects", index:0,value:[],error:''},{id:"months",index:0, value:'',error:''},
            {id:"long_term_storage",index:0, value:'',error:''},
            {id:"erns", index:0, value:'',error:''}, {id:"tissues",index:0, value:'',error:''},
            {id:"LibraryStrategy",index:0, value:'',error:''},{id:"kits", index:0,value:'',error:''},
            {id:"EGA", index:0,value:'',error:''},{id:"LibraryIsize",index:0, value:'',error:''} 
          ]
        ]
    );
    const [experimentOwner, setExperimentOwner] = useState("----");
    const [experimentOwnerValid, setExperimentOwnerValid] = useState(false);
    const [experimentOwnerError, setExperimentOwnerError] = useState("");
    const [redirect, setRedirect ] = useState(false);
    const [redirectContents, setRedirectContents ] = useState([[]]);
    const [redirectFailContents, setRedirectFailContents ] = useState([[]]);
    const [copyReason, setCopyReason ] = useState(false);
    const [popupErrors, setPopupErrors ] = useState("");
    const [csvFileName, setCsvFileName ] = useState("");
    const [loadData, setLoadData ] = useState(true);
    const [submission, setSubmission] = useState(false);
    const [validated, setValidated] = useState(false);
    const [initLoadTsv, setInitLoadTsv] = useState(false);
    
    const resetStateForms = () => {
        // Reset all values
        const newFormControls = resetFormControls(formControls, headers);
        setFormControls(newFormControls);
    }

    const update12monthsHeader = (currentFormControls, currentHeaders) => {
        //Update twelve months until embargo if needed
        let headerMonths = currentHeaders.find(item => { return item.id === "months"});
        if ( isSolveRDSelected(currentFormControls)){
            if (! headerMonths.selection.includes('12')){
                headerMonths.selection.push('12');
                setHeaders(currentHeaders);
            }
        }
        else{
            if (headerMonths.selection.includes('12')){
                headerMonths.selection.splice(headerMonths.selection.indexOf('12'),1);
                setHeaders(currentHeaders);
            }
        }
    }

    const showHideEmbargoPeriodReason = (currentFormControls, currentHeaders) => {
        const embargoReason = { id:"embargoPeriodReason", title : "Embargo Period Reason", inputType:"text",  width :250,
                                description:"Please specify why embargo period is 12 months.", mandatory:true,selection : []};

        if (isSolveRDSelected(currentFormControls) && isAnyMonths12(currentFormControls)){
            // Add Embargo Period Reason
            if (currentHeaders[4].id !== "embargoPeriodReason"){
                currentHeaders.splice(4, 0, embargoReason);
                /*Add Embargo Period Reasion on form Controls*/
                addEmbargoPeriodReason(currentFormControls);
                setHeaders(currentHeaders);
                setFormControls(currentFormControls);
            }
        }
        else{
            // Remove Embargo Reason From Headers
            let index =  currentHeaders.findIndex(item => { return item.id === "embargoPeriodReason"});
            // Remove embargo period reason
            if (index > -1) {
                currentHeaders.splice(index, 1);
                removeEmbargoPeriodReason(currentFormControls,index);
                setHeaders(currentHeaders);
                setFormControls(currentFormControls);
            }
        }
    }

    const loadFile = async (data) => {
        if(Array.isArray(data) && data[0].length>1){
            //Reset Forms
            resetStateForms();
            //Update Load Data to True
            setLoadData(true);
            //Get current form control to later modify it
            let currentFormControls = [...formControls];
            // Get Current Headers
            let currentHeaders = [...headers];
            //Loop Over all Data
            let isFirst = true;
            let rowNumber = 0;
            let headerTitles = [];
            for (let row of data){
                //1. Avoid Header
                if(isFirst){
                    isFirst = false;
                    headerTitles = row; 
                } else {
                    //Check if Form Controls has an array to fulfill it or not
                    if(rowNumber >= currentFormControls.length){
                        //Generate new item
                        addRows(1,currentFormControls, currentHeaders);
                    }
                    let colNumber = 0;
                    for (let column of row){
                        //Update value
                        let correctedColNumber = currentHeaders.findIndex(item => item.title === headerTitles[colNumber]);
                        if (Array.isArray(currentFormControls[rowNumber][correctedColNumber].value)) {
                            currentFormControls[rowNumber][correctedColNumber].value.push(column);
                            //Check Special Cases
                            switch (currentFormControls[rowNumber][correctedColNumber].id) {
                                case "Projects":
                                    update12monthsHeader(currentFormControls, currentHeaders);
                                    showHideEmbargoPeriodReason(currentFormControls,currentHeaders);
                                    break;
                                case "months":
                                    showHideEmbargoPeriodReason(currentFormControls,currentHeaders);
                                    break;
                            }
                        } else if(currentFormControls[rowNumber][colNumber].id === "Participant_ID") {
                            // Call API Endpoint
                            if (column !== "") {
                                let data_query = {"page" : 1, "pageSize" : 100, "fields":["report_id"], "filtered":[{"id":"report_id","value":column}]}
                                const response =   await participant_list(auth.getToken(),config.pheno_api_endpoint, JSON.stringify(data_query))
                                const data = await response.json();
                                parseSelectServerSide(data["rows"],currentFormControls[rowNumber][colNumber],"report_id",column);
                            }
                        } else {
                            currentFormControls[rowNumber][correctedColNumber].value = column;
                        }
                        colNumber ++;
                    }
                    rowNumber ++;
                }
            }
            //Validate File Inputs
            await validateForm(currentFormControls, currentHeaders, experimentOwner, auth.getToken(), config.api_endpoint);
            //Update Form Control State
            setHeaders(currentHeaders);
            setFormControls(currentFormControls);
            setNumberRows(currentFormControls.length);
            setLoadData(false);
        } else {
           alert("File in wrong format. Please convert to Tab-Limited and upload again.")
        }
    }

    const pushRows = (nRows) => {
        // Get current form control to later modify it
        let currentFormControls = [...formControls];
        // Add Rows
        addRows(nRows,currentFormControls, headers);
        // Update Form Control State
        setFormControls(currentFormControls);
        setNumberRows(currentFormControls.length)
    }

    const updateRowsOwnerCsvFile = () => {
        // Last things to do after the REST calls are done on the use effect
        // 1. push 9 rows
        pushRows(9);
        // 2. Update group owner from previous dialog
        if (props.location.owner !== undefined ) {
            setExperimentOwner(props.location.owner);
            setExperimentOwnerValid(true);
        }
        // 3. Report Load process finished
        setLoadData(false);
        setInitLoadTsv(true);
    }

    useEffect(() => {
        if (initLoadTsv) {
            // Load data from csv
            if (props.location.data !== undefined) {
                loadFile(props.location.data);
                setInitLoadTsv(false);
            }
        }
    },[initLoadTsv])

    // On load for the first time
    useEffect(() => {
        if (auth.tokenExpired()) {
            // Logging check
            setPopupErrors("Logging session timeout. Please log again");
        } else {
            // Load data from Rest API to the backend
            fetchHeadersList(headers,auth.getToken(),config.api_endpoint).then(
                result => {
                    setHeaders(result); 
                    //Special calls if subproject is set
                    if (config.subproject) {
                        fetchSubprojectList(headers, formControls, auth.getToken(),config.api_endpoint).then(
                            retSub => {
                                setHeaders(retSub[0]);
                                setFormControls(retSub[1]);
                                updateRowsOwnerCsvFile();
                            }
                        );
                    }
                    else {
                        updateRowsOwnerCsvFile();
                    }                    
                }
            ); 
        }
    },[])

    const closeModal = () => {
        setPopupErrors("");
        setRedirectContents([[]]);
        setRedirectFailContents([[]]);
    }

    const submit = async (event) => {
        event.preventDefault();
        /*0. Validate*/
        setSubmission(true);
        /*0.1 Get current form control to later modify it */
        let currentFormControls = [...formControls];
        await validateForm(currentFormControls, headers, experimentOwner, auth.getToken(), config.api_endpoint);
        /*0.2 Validate Group Owner*/
        if (!experimentOwnerValid) {
            setPopupErrors("No valid group owner selected!");
            setSubmission(false);
            return;
        }
        /*1. Check If From Has Errors*/
        if (!hasErrors(currentFormControls) && experimentOwnerValid){
            /* 2. Get fill Form Control*/
            const experimentRows = getFilledRows(currentFormControls, headers);
            /* 2.1. Table Experiments Succesfully created */
            let tableContentsInserted = [["Experiment ID", ...headers.map(row => { return row.title; })]];
            /* 2.2. Table Experiments failed on creation */
            let tableFails = [["Local Experiment ID", "Error Message"]];
            /*3. For Each Row Submit Experiment Info To Experiments API*/
            for (let row of experimentRows) {
                /*3.1. Generate data to send POST request*/
                let data = { "Owner" : experimentOwner };
                for(let col of row) {
                    data[getApiKey(col.id)] = col.value;
                }
                data["read_insert_size"] = (data["read_insert_size"] === "") ? 0 : parseInt(data["read_insert_size"]);
                data["months_until_embargo"] = parseInt(data["months_until_embargo"]);
                /* 3.1.1 Map YES/NO values for lin term storage */
                if ("long_term_storage" in data) data["long_term_storage"] = (data["long_term_storage"] === "YES") ? true : false;
                /*3.2 Define API POST Request*/
                const response = await experiment_create(auth.getToken(),config.api_endpoint,JSON.stringify(data));
                let text = await response.text()
                /*3.3 Check Status*/
                if (response.status !== 200) {
                    tableFails.push([data["Submitter_ID"], text]);
                } else {
                    /*3.3.1 Build Experiments inserted array*/
                    let assignedId = text.replace(/\"/g,"");
                    tableContentsInserted.push(
                        [
                            assignedId,
                            ...row.map(item => {    
                                if (Array.isArray(item.value)){
                                    return [...new Set(item.value)].join(' ')
                                }
                                return item.value;
                            })
                        ]
                    );
                }
            }
            /* 4. Report experiment batch results*/
            /* 4.1 Go to Summary Inserted ----> REPLACE with SUCCESSFUL, and go to SUMMARY*/
            let today = new Date().toISOString().slice(0, 10);
            setCsvFileName(`${today}_submitted_experiments.csv`);
            setRedirectContents(tableContentsInserted);
            if (tableFails.length > 1) setRedirectFailContents(tableFails);
            setRedirect(true);
            setSubmission(false);
        } else {
            //Update State
            setFormControls(currentFormControls);
            setSubmission(false);
        }
    }

    const reload = event => {
        resetStateForms();
    }
    
    const getExcel = async (event) => {
        // Get Experiments Excel template from backend
        getExperimentExcel(formControls);
    }

    const validateGroupOwner = (newBoolean) => {
        // Set Validation Value Owner Selection
        setExperimentOwnerValid(newBoolean); 
        if (newBoolean) setExperimentOwnerError("");
    }
   
    const validate = async (event) => {
        //Get current form control to later modify it
        let currentFormControls = [...formControls];
        //Validate Forms
        await validateForm(currentFormControls, headers, experimentOwner, auth.getToken(), config.api_endpoint);
        //Validate Group Owner Selected
        if(experimentOwner === "----") {
            setExperimentOwnerError("Sorry! No valid group choice selected!");
            setExperimentOwnerValid(false);
        } else {
            setExperimentOwnerError("");
            setExperimentOwnerValid(true);
        }
        //Update State
        setFormControls(currentFormControls);
        setValidated(true);
    }

    const changeHandler = event => {
        const name = event.target.name;
        const value = event.target.value;
        const id = name.split("-")[0];
        const index = name.split("-")[1];

        let currentFormControls = [...formControls];
        let rowControls = [...currentFormControls[index]];
        let fieldControl = rowControls.find(item => { return item.id === id});

        if (Array.isArray(fieldControl.value))
        {
            const indexField = fieldControl.value.indexOf(value);
            if (indexField === -1) fieldControl.value.push(value);
            else fieldControl.value.splice(indexField,1);
        } else {
            fieldControl.value = value;
        }
        // Process special case Months Until Embargo 12
        let currentHeaders = [...headers];

        if ( id === "Projects")
        {
            let headerMonths = currentHeaders.find(item => { return item.id === "months"});
            if ( isSolveRDSelected(currentFormControls)){
                if (! headerMonths.selection.includes('12')){
                    headerMonths.selection.push('12');
                }
            } else {
                if (headerMonths.selection.includes('12')){
                    headerMonths.selection.splice(headerMonths.selection.indexOf('12'),1);
                }
            }
        }
        // Process special case months == 12 
        if ( id === "months" || id === "Projects") {
            const embargoReason = { id:"embargoPeriodReason", title : "Embargo Period Reason", inputType:"text",
                                    description:"Please specify why embargo period is 12 months.", mandatory:true,
                                    selection : [], width:300};

            if (isSolveRDSelected(currentFormControls) && isAnyMonths12(currentFormControls)){
                // Add Header Embargo Period Reason
                if (currentHeaders[4].id !== "embargoPeriodReason"){
                    currentHeaders.splice(4, 0, embargoReason);
                    // Add Embargo Period Reasion on form Controls
                    addEmbargoPeriodReason(currentFormControls);
                }
            } else {
                // Remove Embargo Reason From Headers 
                let index =  headers.findIndex(item => { return item.id === "embargoPeriodReason"});
                // Remove embargo period reason
                if (index > -1) {
                    currentHeaders.splice(index, 1);
                    removeEmbargoPeriodReason(currentFormControls,index);
                }
            }
        }
        //Update Headers
        setHeaders(currentHeaders);
        //Update From Controls
        setFormControls(currentFormControls);
    }
    
    // Checkbox Emabrgo Reason Periond Handler
    const embargoHandler = event =>
    {
        //If checbox clicked then copy first row emabargo reason over all embargo reason rows. Otherwise clean all embargo reason rows
        let newCopyReason = !copyReason;
        let currentFormControls = [...formControls];
        let embargoReason = "";
        for (let row of currentFormControls){
            let embargoColumn = row.find(item => { return item.id === "embargoPeriodReason"});
            if (embargoColumn.index === 0){
                embargoReason = newCopyReason ? embargoColumn.value : "";
            }
            else{
                embargoColumn.value = embargoReason;
            }
        }
        //Update State
        setCopyReason(newCopyReason);
        setFormControls(currentFormControls);
    }
    
    const loadParticipants = async (search, loadedOptions, { page }) => {
        /*Call API Endpoint*/
        let data_query = {"page" : page, "pageSize" :100, "fields":["report_id"], "filtered":[{"id":"report_id","value":search}]};
        const response = await participant_list(auth.getToken(),config.pheno_api_endpoint, JSON.stringify(data_query));
        const data = await response.json();
        /*Has More*/
        let hasMore = false;
        if (page < data["pages"]) {
            hasMore = true;
            page = page +1;
        }
        //Create Select Options
        let options = [];
        let value = 0;
        for (let item of data["rows"]){
            //2. Add option
            options.push({value:value, label:item["report_id"]});
            value = value + 1;
        }
        //Return settings for select experiments
        return {
            options: options,
            hasMore: hasMore,
            additional: {
                page: page,
            },
        };
    } 

    const changeSelectAutocomplete = (newValue, actionMeta) => {
        // On Change Hanler for AsyncPaginate react Select Component used for Experiment Selection
        const id = actionMeta.name.split("-")[0];
        const index = actionMeta.name.split("-")[1];
        // Update State With Selected Value
        let currentFormControls = [...formControls];
        let rowControls = [...currentFormControls[index]];
        let fieldControl = rowControls.find(item => { return item.id === id});
        // Update Value
        fieldControl.valueIndex = newValue;
        fieldControl.value = newValue.label;
        setFormControls(currentFormControls);
    }

    const addRow = event => {
        const id = event.target.id;
        let nRows = parseInt(id.split("-")[1]);
        pushRows(nRows);
    }

    const setOwnerGroup = (owner)  => {
        //Modify Owner Group State
        setExperimentOwner(owner);
    }

    // JSX component return

    // Report erros
    let formErrors = getNumbersErrors(formControls);
    if (!experimentOwnerValid) formErrors = formErrors + 1;
    // Show popup in case an error with the loggin occurs
    if (popupErrors ) {
        return (
            <SubmissionPopupError 
                errors={popupErrors}
                tableContents={redirectContents}
                onClose={closeModal}
            />
        );
    }
    // Loading Spin while csv file is read
    if(loadData) {
        return(
            <div className={"mainContent"}>
                <LoadingSpinner />
            </div>
        );
    }

    // Experiment Submission view
    return (
        <div className={"mainContent"}>
            {(redirect && formErrors === 0)
                ? 
                    <SubmissionDialog 
                        type={"Experiments"}
                        onClose={()=> setRedirect(false)} 
                        tableContents={redirectContents} 
                        tableFailContents={redirectFailContents}
                        filename={csvFileName} 
                        open={redirect}
                    />
                : null
            }
            
            <SubmissionHeader title={"Submit Experiments"} addRow={addRow} 
                              validate={validate} submit={submit} 
                              reload={reload} loadFile={loadFile} 
                              getExcel={getExcel} 
                              owner={experimentOwner} ownerValid={validateGroupOwner} 
                              setOwner={setOwnerGroup}  ownerError={experimentOwnerError}/>

                           
            {(validated)  ? 
                <ErrorDialog
                    onClose={()=>setValidated(false)}
                    errors={formErrors}
                />
                :  null
            }
            
            { submission  ? 
                <Box sx={{ width: '100%' }}>
                    <Typography variant="body1">Updating database...</Typography>
                    <LinearProgress />
                </Box> 
              :  
                <TableSubmit headers={headers} contents={formControls}
                    changeHandler={changeHandler} embargoHandler={embargoHandler}
                    copyReason={copyReason} loadParticipants={loadParticipants}
                    changeSelectAutocomplete={changeSelectAutocomplete} loading={loadData}/>
            }
        </div>
    );    

}

export default SubmitExperiment;    
